import React from 'react';
import { observer } from 'mobx-react-lite';
import { RenewalActionsDelegate } from 'store/modules/initiate-quote/renewalActionsDelegate';
import { INITIATE_PROPOSAL_RENEWAL_ACTIONS_LIST_TEST_ID } from './constants';
import RenewalAction from './RenewalAction';
import { RenewalActionsListStyled } from './styles';

interface Props {
  renewalActionsDelegate: RenewalActionsDelegate;
}

const RenewalActions: React.FC<Props> = observer(({ renewalActionsDelegate: { renewalActions } }) => {
  return (
    <RenewalActionsListStyled data-test-id={INITIATE_PROPOSAL_RENEWAL_ACTIONS_LIST_TEST_ID}>
      {renewalActions.map((renewalAction) => (
        <RenewalAction key={renewalAction.action} renewalAction={renewalAction} />
      ))}
    </RenewalActionsListStyled>
  );
});

export default RenewalActions;
